import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRequestService } from '../shared/api-request.service';
import { AuditItemModel } from './audit-item.model';
import { ApiResponseModel } from '../models/api-response.model';

type ResponseItem = ApiResponseModel<AuditItemModel>;
type ResponseItems = ApiResponseModel<AuditItemModel[]>;

@Injectable({
  providedIn: 'root'
})
export class AuditItemsService {
  constructor(private api: ApiRequestService) {}

  post(auditItem: AuditItemModel): Observable<ResponseItem> {
    return this.api.makeRequestObservable('post', 'v1/audit-items', auditItem);
  }

  remove(ids: number[]): Observable<{}> {
    return this.api.makeRequestObservable('delete', `v1/audit-items/${ids}`);
  }

  find(id: number): Observable<ResponseItem> {
    return this.api.makeRequestObservable('get', `v1/audit-items/${id}`);
  }

  get(): Observable<ResponseItems> {
    return this.api.makeRequestObservable('get', 'v1/audit-items');
  }

  put(auditItem: AuditItemModel): Observable<{}> {
    return this.api.makeRequestObservable(
      'put',
      `v1/audit-items/${auditItem.id}`,
      auditItem
    );
  }

  getSections(): Observable<ApiResponseModel<string[]>> {
    return this.api.makeRequestObservable('get', 'v1/audit-items/sections');
  }

  public submit(item: AuditItemModel, files: FileList) {
    const form = new FormData();
    Array.from(files).forEach((file) => form.append(file.name, file));
    form.append('_method', 'PUT');
    return this.api.makeRequestObservable(
      'put',
      `v1/audit-items/submit/${item.id}`,
      form
    );
  }
}
